import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";

import styles from "./BaraAreaAlunoRelatorio.module.scss";

export default function BarraAreaAlunoRelatorio({ title, code }) {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const entidade = pathParts[1];

    const [curso, setCurso] = useState(undefined);

    const nomeCurso = () => {
        axios({
            method: "get",
            url: "/api/area-aluno/info-turma",
            params: {
                code
            }
        }).then(response => {
            setCurso(response.data);
        });
    };

    useEffect(() => {
        nomeCurso();
    }, []);

    return (
        <div className={styles.barra}>
            <div className={styles.nome}>
                <span> {title} - {curso}</span>
            </div>
            <div className={styles.seta}>
                <Link to={`/${entidade}/area-aluno`}>
                    <FaArrowLeft />
                </Link>
            </div>
        </div>
    );
}
